import * as React from "react";

import { AppShape, EmploymentShape, HurdleShape } from "@eave/shared/types/api";
import APIClient from "../../../APIClient";
import WVoERequestForm, { ContactMethodDocusign } from "./WVoERequestForm";
import WVoEReviewForm from "./WVoEReviewForm";
import LabeledInput from "../../../LabeledInput";

import { loadApp } from "../../actions";

require("../../../../assets/stylesheets/components/underwriter_dashboard/hurdle_editors/wvoe.scss");
const { Button, Panel } = require("react-bootstrap");

interface WVoEForEmploymentProps {
  app: AppShape;
  employment: EmploymentShape;
  hurdle: HurdleShape;
  dispatch?: Function;
}

class WVoEForEmployment extends React.Component<WVoEForEmploymentProps, any> {
  constructor(props) {
    super(props);
    this.state = {
      notes: props.employment.wvoe_signature_request.notes,
    };
  }

  fetchStatusUpdateFromDocusign() {
    const { dispatch, app, employment } = this.props;
    APIClient.get(`/${app.id}/wvoe/${employment.id}`).then(() => {
      loadApp(dispatch, app.id);
    });
  }

  status() {
    const { employment } = this.props;

    if (!employment.wvoe_signature_request.id) {
      return "WVoE not triggered";
    }
    if (employment.wvoe_signature_request.envelope_id === null) {
      return "WVoE needs to be completed by Eave";
    }
    if (
      employment.wvoe_signature_request.all_signed &&
      employment.wvoe_signature_request.contact_method === ContactMethodDocusign
    ) {
      return "WVoE Completed";
    }
    if (
      employment.wvoe_signature_request.employee_signed &&
      employment.wvoe_signature_request.contact_method === ContactMethodDocusign
    ) {
      return "WVoE signed by borrower. Waiting for employer to complete.";
    }
    if (
      employment.wvoe_signature_request.all_signed &&
      !employment.wvoe_signature_request.sent_to_employer_at &&
      employment.wvoe_signature_request.contact_method !== ContactMethodDocusign
    ) {
      return (
        `WVoE signed by borrower. Eave needs to send to employer via` +
        `${employment.wvoe_signature_request.contact_method}`
      );
    }
    if (
      employment.wvoe_signature_request.all_signed &&
      employment.wvoe_signature_request.sent_to_employer_at &&
      employment.wvoe_signature_request.contact_method !== ContactMethodDocusign
    ) {
      return (
        `WVoE signed by borrower. Waiting for employer to complete (sent` +
        `via ${employment.wvoe_signature_request.contact_method}).`
      );
    }
    if (
      employment.wvoe_signature_request.employee_signed &&
      !employment.wvoe_signature_request.sent_to_employer_at
    ) {
      return (
        `WVoE signed by borrower. Eave needs to send to employer` +
        `via ${employment.wvoe_signature_request.contact_method}`
      );
    }
    if (
      employment.wvoe_signature_request.employee_signed &&
      employment.wvoe_signature_request.sent_to_employer_at
    ) {
      return (
        `WVoE signed by borrower. Waiting for employer to complete` +
        `(sent via ${employment.wvoe_signature_request.contact_method}).`
      );
    }
    if (
      employment.wvoe_signature_request.envelope_id !== null &&
      !employment.wvoe_signature_request.all_signed
    ) {
      return `WVoE sent to borrower for signature`;
    }
    return "¯\\_(ツ)_/¯";
  }

  triggerWVoE() {
    const { app, dispatch, employment } = this.props;

    APIClient.post(`/${app.id}/wvoe/${employment.id}`, {}).then(() => {
      loadApp(dispatch, app.id);
    });
  }

  renderTriggerWVoEButton() {
    return (
      <p>
        <Button bsSize="small" onClick={this.triggerWVoE.bind(this)}>
          <i className="fa fa-check-circle" />
          Trigger WVoE
        </Button>
      </p>
    );
  }

  renderStatusSection() {
    return (
      <div>
        <p>Status: {this.status()}</p>
        <p>
          <Button bsSize="small" onClick={this.fetchStatusUpdateFromDocusign.bind(this)}>
            <i className="fa fa-check-circle" />
            Check Status
          </Button>
        </p>
      </div>
    );
  }

  saveNotes() {
    const { app, dispatch, employment } = this.props;

    APIClient.put(`/${app.id}/wvoe_notes/${employment.id}`, {
      notes: this.state.notes,
    }).then(() => {
      loadApp(dispatch, app.id);
    });
  }

  renderNotesSection() {
    return (
      <div>
        <LabeledInput
          labelValue="Notes"
          inputType="textarea"
          inputName="notes"
          inputValue={this.state.notes}
          onChange={e => this.setState({ notes: e.target.value })}
        />
        {this.state.notes !== this.props.employment.wvoe_signature_request.notes && (
          <Button bsSize="small" onClick={this.saveNotes.bind(this)}>
            <i className="fa fa-check-circle" />
            Save Note
          </Button>
        )}
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderStatusSection()}

        {this.props.employment.wvoe_signature_request.id === 0 && this.renderTriggerWVoEButton()}
        {this.props.employment.wvoe_signature_request.id !== 0 && (
          <Panel>
            <Panel.Body>
              <WVoERequestForm
                app={this.props.app}
                employment={this.props.employment}
                dispatch={this.props.dispatch}
              />
            </Panel.Body>
          </Panel>
        )}
        {/* STEP 4: automatically or manually send to employer to fill out */}
        {/* STEP 5: automatically or manually ingest values */}
        {this.props.employment.wvoe_signature_request.id !== 0 && (
          <Panel>
            <Panel.Body>
              <WVoEReviewForm
                app={this.props.app}
                employment={this.props.employment}
                hurdle={this.props.hurdle}
                dispatch={this.props.dispatch}
              />
            </Panel.Body>
          </Panel>
        )}
        {this.props.employment.wvoe_signature_request.id !== 0 && this.renderNotesSection()}
      </div>
    );
  }
}

export default WVoEForEmployment;
